module.exports = __webpack_public_path__ + "img/discover-bg.0ae05a86.png";